import { useMutation } from '@tanstack/react-query'
import { getPointOrderId } from '../../../service/point'

export const useGetPointOrderId = () => {
  return useMutation({
    mutationKey: ['get-point-orderId'],
    mutationFn: getPointOrderId,
  })
}
